import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export default function Insights({ limit = 4 }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/blog").then(({ data }) => setItems(data.slice(0, limit))).catch(() => {});
  }, [limit]);
  if (!items.length) return null;
  return (
    <section className="relative section-pad overflow-hidden" data-testid="insights-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-4">09 · Insights</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1]">
              Writing from the<br /><span className="italic">build floor</span>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
            <Link to="/insights" className="inline-flex items-center gap-2 text-[13px] font-medium link-underline" data-testid="insights-view-all">
              All articles <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05}>
              <Link to={`/insights/${p.slug}`} className="block group card-surface overflow-hidden" data-testid={`insight-${p.slug}`}>
                <div className="aspect-[4/3] overflow-hidden relative">
                  <div className="absolute inset-0 z-10 pointer-events-none" style={{ background: "radial-gradient(circle at 30% 30%, rgba(37,99,235,0.25), transparent 60%)" }} />
                  <img src={p.cover_image || "https://images.unsplash.com/photo-1677080865283-26f94ed332f1?w=1200"} alt={p.title}
                       className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="overline mb-2">{p.category}</div>
                  <h3 className="font-serif text-xl md:text-[22px] leading-tight tracking-tight">{p.title}</h3>
                  <p className="mt-2 text-[13px] text-[color:var(--text-muted)] leading-relaxed line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
